enum QUESTION_IMAGE_POSITION {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export default QUESTION_IMAGE_POSITION;
